/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-13 15:44:54
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import Input from "src/types/iview/Input";
import {Toast} from "src/util/toast";
import {modalFactory} from "src/util/vueExtend";
import EnumOperates from "src/enums/enumOperates";
import MenuConfigApi from './api/menuConfigApi';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumAuthorityType from 'src/enums/enumAuthorityType';

export namespace OperateMenuVOI {
	export interface PropsI {
		operate: string
		id?: number

		saveSuccess? (): void

		cancel? (): void
	}

	export interface FormDataI {
		power_name: string
        power_url: string
        type: 1|2
	}
}

@Component
class OperateMenuModal extends Vue.Component<OperateMenuVOI.PropsI> {
	@Prop({
		type: Function
	})
	cancel!: () => void

	@Prop({
		type: Number
	})
	id!: number

	@Prop({
		type: String
	})
	operate!: string

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

	formData: OperateMenuVOI.FormDataI = {
		power_name: '',
        power_url: '',
        type: 1
	}
	rules: any = {
		name: [
			{required: true, message: '请输入名称', trigger: 'change'}
		],
	}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
	}

	async save () {
		if(!await this.$validate('formValidate')) {
			return
		}
		let res
		this.loading = true
		let params = {
			...this.formData,
		}
		switch (this.operate) {
			case EnumOperates.Add.getName():
				res = await MenuConfigApi.add(params)
				break
			case EnumOperates.Update.getName():
				break
		}
		this.loading = false
		let {code} = res
		if (code === 0) {
			Toast.success(this.operate+'成功')
			this.saveSuccess()
			this.closeModal()
		}
	}

	render (h) {
		return (
			<Modal
				title={this.operate+'菜单'}
				width="500"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
				<i-form ref="formValidate" labelWidth={100} model={this.formData}>
                    <form-item label="名称" prop="power_name" required style="width:80%">
                        <Input v-model={this.formData.power_name} placeholder="请输入" />
                    </form-item>
                    <form-item label="url" prop="power_url" required style="width:80%">
                        <Input v-model={this.formData.power_url} placeholder="请输入" />
                    </form-item>
                    <form-item label="权限类型" prop="type" required style="width:80%" type="number">
                        <CommonSelect v-model={this.formData.type} dataSource={EnumAuthorityType.getList()}></CommonSelect>
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
			</Modal>
		);
	}
}

export default function alertOperateMenuModal (operate: string, id?: number): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<OperateMenuVOI.PropsI>(OperateMenuModal)({
				id,
				operate,
				saveSuccess () {
					resolve(true)
				},
				cancel () {
					resolve(false)
				}
			})
		})
	}
